import { CardHeader } from '@ps/isp-web-component-library';
import React from 'react';

import PopularAccumulatorCount from '../PopularAccumulatorCount/PopularAccumulatorCount';

import styles from './PopularAccumulatorCardHeader.scss';
import bgImage from './header-bg.png';

interface Props {
  count: number;
}

const PopularAccumulatorCardHeader: React.FC<Props> = ({ count }) => (
  <CardHeader className={styles.cardHeader}>
    <div className={styles.background}>
      <div className={styles.container} style={{ backgroundImage: `url(${bgImage})` }}>
        <div className={styles.iconOuter}>
          <div className={styles.countInner}>
            <PopularAccumulatorCount count={count} />
          </div>
        </div>
      </div>
    </div>
  </CardHeader>
);

export default PopularAccumulatorCardHeader;
